<template>
  <div>
    <v-alert dense type="success">
      <div class="alert alert-info" role="alert">
        <b>Hinweis:</b> Alle offenen Einträge werden jede Nacht automatisch beendet!
      </div>
    </v-alert>

    <v-data-table
      :headers="headers"
      :items="comp_OpenShootingBookEntry"
      sort-by="nummer"
      class="elevation-1"
      no-data-text="Du hast zur Zeit keine offenen Einträge"
    >
      <template v-slot:top>
        <v-toolbar flat dense color="success" dark>
          <v-toolbar-title>Offene Schiessbuch Einträge</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="getOpenShootingBookEntry">
            <v-icon>mdi-reload</v-icon>
          </v-btn>
        </v-toolbar>
      </template>

      <template v-slot:item.shooting_function_name="{ item }">
        <span>{{ item.shooting_function_name || item.Aufsicht || item.funktion_name || (isNaN(item.funktion) ? item.funktion : getFunctionName(item.shooting_function_id || item.funktion)) }}</span>
      </template>

      <template v-slot:item.beginn="{ item }">
        <span>{{
            new Date(item.beginn.replace(" ", "T")).toLocaleString([], { dateStyle: "short", timeStyle: "short" })
          }}</span>
      </template>

      <template v-slot:item.actions="{ item }">
        <div class="d-flex justify-center">
        <v-btn
          icon
          color="info"
          @click="editItems(item)"
        >
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
        <v-dialog
          v-model="dialog"
          transition="dialog-top-transition"
          max-width="800"
          :retain-focus="false"
        >
          <v-card>
            <v-card-title class="text-h5">
              Eintrag bearbeiten
            </v-card-title>

            <v-card-text>
              <v-container fluid class="pa-2 pa-sm-4">
                <!-- Verein, Stand & Bahn Section -->
                <v-card outlined class="mb-4">
                  <v-card-subtitle class="pb-2">Standort</v-card-subtitle>
                  <v-card-text>
                    <v-text-field
                      label="Verein"
                      v-model="editItem.Club"
                      outlined
                      dense
                      hide-details="auto"
                      class="mb-3"
                      readonly
                      disabled
                    ></v-text-field>

                    <v-text-field
                      label="Stand"
                      v-model="editItem.ClubRange"
                      outlined
                      dense
                      hide-details="auto"
                      class="mb-3"
                      readonly
                      disabled
                    ></v-text-field>

                    <v-text-field
                      label="Bahn"
                      v-model="editItem.Place"
                      outlined
                      dense
                      hide-details="auto"
                      readonly
                      disabled
                    ></v-text-field>
                  </v-card-text>
                </v-card>

                <!-- Aktivität & Funktion Section -->
                <v-card outlined class="mb-4">
                  <v-card-subtitle class="pb-2">Aktivität & Funktion</v-card-subtitle>
                  <v-card-text>
                    <v-text-field
                      label="Funktion"
                      v-model="editItem.shootingActionText"
                      outlined
                      dense
                      hide-details="auto"
                      class="mb-3"
                      readonly
                      disabled
                    ></v-text-field>

                    <v-text-field
                      label="Aktivität"
                      v-model="editItem.aktivitaet"
                      outlined
                      dense
                      hide-details="auto"
                      readonly
                      disabled
                    ></v-text-field>
                  </v-card-text>
                </v-card>

                <!-- Waffe, Disziplin & Zeit Section -->
                <v-card outlined class="mb-4">
                  <v-card-subtitle class="pb-2">Waffe & Zeitpunkt</v-card-subtitle>
                  <v-card-text>
                    <v-text-field
                      label="Waffe"
                      v-model="editItem.OwnWeapon"
                      outlined
                      dense
                      hide-details="auto"
                      class="mb-3"
                      readonly
                      disabled
                    ></v-text-field>

                    <v-datetime-picker
                      label="Beginn"
                      date-format="dd.MM.yyyy"
                      time-format="HH:mm"
                      v-model="editItem.Begin"
                      :retain-focus="false"
                      :text-field-props="{ outlined: true, dense: true, hideDetails: 'auto', class: 'mb-3' }"
                      :time-picker-props="timePickerProps"
                      :date-picker-props="datePickerProps"
                    >
                      <template slot="dateIcon">
                        <v-icon>mdi-calendar</v-icon>
                      </template>
                      <template slot="timeIcon">
                        <v-icon>mdi-clock-outline</v-icon>
                      </template>
                    </v-datetime-picker>

                    <v-datetime-picker
                      label="Ende"
                      date-format="dd.MM.yyyy"
                      time-format="HH:mm"
                      v-model="editItem.Ende"
                      :retain-focus="false"
                      :text-field-props="textFieldPropsCustom"
                      :time-picker-props="timePickerProps"
                      :date-picker-props="datePickerProps"
                    >
                      <template slot="dateIcon">
                        <v-icon>mdi-calendar</v-icon>
                      </template>
                      <template slot="timeIcon">
                        <v-icon>mdi-clock-outline</v-icon>
                      </template>
                    </v-datetime-picker>
                  </v-card-text>
                </v-card>

                <!-- Ergebnis Section -->
                <v-card outlined class="mb-4">
                  <v-card-subtitle class="pb-2">Ergebniss erfassen</v-card-subtitle>
                  <v-card-text>
                    <v-text-field
                      label="Schuss"
                      v-model="editItem.AnzSchuss"
                      outlined
                      dense
                      hide-details="auto"
                      class="mb-3"
                      type="number"
                      min="1"
                      max="5000"
                    ></v-text-field>

                    <v-text-field
                      label="Ergebniss"
                      v-model="editItem.Summe"
                      outlined
                      dense
                      hide-details="auto"
                    ></v-text-field>
                  </v-card-text>
                </v-card>
              </v-container>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions class="px-4 py-3">
              <v-btn
                color="grey darken-1"
                text
                @click="dialog = false"
              >
                Abbrechen
              </v-btn>

              <v-spacer></v-spacer>

              <v-btn
                color="success"
                large
                @click="save()"
              >
                <v-icon left>far fa-save</v-icon>
                Speichern
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-btn
          icon
          color="error"
          @click="delShootingBookEntry_Dialog(item)"
        >
          <v-icon>mdi-trash-can</v-icon>
        </v-btn>
        </div>

      </template>

    </v-data-table>
    <v-dialog v-model="dialogDelete" max-width="500px" :retain-focus="false">
      <v-card>
        <v-card-title class="text-h5">Willst du diesen Eintrag wirklich löschen?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialogDelete = false; prepare_delete_item = {}">Abbrechen</v-btn>
          <v-btn color="blue darken-1" text @click="delShootingBooKEntry()">OK</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

export default {
  name: "OpenShootingBookEntry",
  data: () => ({
    dialogDelete: false,
    headers: [
      {
        align: "Verein",
        sortable: false
      },
      { text: "Verein", value: "name" },
      { text: "Funktion", value: "shooting_function_name" },
      { text: "Aktivität", value: "aktivitaet" },
      { text: "Stand", value: "KurzBez" },
      { text: "Bahn", value: "bahn" },
      { text: "Waffe", value: "KurzT" },
      { text: "Begin", value: "beginn" },
      { text: "Actions", value: "actions", sortable: false, align: "center" }
    ],
    dialog: false,
    editItem: {
      SB_EDIT_ID: null,
      Club: null,
      shootingAction: null,
      shootingActionText: null,
      aktivitaet: null,
      ClubRange: null,
      OwnWeapon: null,
      Disziplin: null,
      Begin: null,
      Place: null,
      Ende: new Date(),
      AnzSchuss: null,
      Summe: null
    },
    anzahlschuss: [
      { id: 1, value: 10 },
      { id: 2, value: 20 },
      { id: 3, value: 30 },
      { id: 4, value: 40 },
      { id: 5, value: 50 },
      { id: 6, value: 60 }
    ],
    textFieldProps: {
      outlined: true
    },
    textFieldPropsCustom: {
      outlined: true,
      dense: true,
      hideDetails: "auto"
    },
    datePickerProps: {},
    timePickerProps: {
      format: "24hr"
    },
    prepare_delete_item: {}
  }),
  computed: {
    comp_OpenShootingBookEntry: {
      get() {
        return this.$store.state.UserApp.OpenShootingBookEntry;
      },
      set() {
      }
    }

  },
  mounted() {
    this.getOpenShootingBookEntry();
  },
  methods: {
    getOpenShootingBookEntry() {
      this.$store.dispatch("UserApp/getOpenShootingBookEntry");
    },
    getFunctionName(id) {
      const map = { 1: "Schütze", 2: "Standaufsicht", 3: "Schießsportleiter" };
      return map[id] || "Unbekannt";
    },
    editItems(item) {
      this.dialog = true;

      // Funktion Text ermitteln
      let funktionText = item.shooting_function_name || item.Aufsicht || item.funktion_name || (isNaN(item.funktion) ? item.funktion : this.getFunctionName(item.shooting_function_id || item.funktion));

      this.editItem.Club = item.name,
        this.editItem.shootingAction = item.shooting_function_id || item.funktion,
        this.editItem.shootingActionText = funktionText,
        this.editItem.aktivitaet = item.aktivitaet,
        this.editItem.ClubRange = item.KurzBez,
        this.editItem.OwnWeapon = item.KurzT,
        this.editItem.Begin = new Date(item.beginn.replace(" ", "T")),
        this.editItem.Place = item.bahn,
        this.editItem.SB_EDIT_ID = item.id,
        this.editItem.AnzSchuss = null,
        this.editItem.Summe = null;
    },
    save() {
      var Data = {
        offeneEditID: this.editItem.SB_EDIT_ID,
        inputEditoffeneBeginn: this.editItem.Begin,
        inputEditoffeneEnde: this.editItem.Ende,
        inputSchuss: this.editItem.AnzSchuss,
        inputEditoffeneTrErgGesamt: this.editItem.Summe
      };
      this.$store.dispatch("UserApp/updateNewShootingBookRecord", Data)
        .then(this.dialog = false);
    },

    delShootingBookEntry_Dialog(item) {
      this.dialogDelete = true;
      this.prepare_delete_item = Object.assign({}, item);
    },

    delShootingBooKEntry() {
      const Data = {
        "shootingbook_id": this.prepare_delete_item.id
      };

      this.$store.dispatch("UserApp/delShootingbookEntry", Data)
        .then(this.dialogDelete = false,
          this.prepare_delete_item = {}
        );
    }
  }

};
</script>

<style scoped>
/* Mobile optimization */
@media (max-width: 600px) {
  .v-card__subtitle {
    font-size: 0.875rem;
    font-weight: 600;
  }
}
</style>